import React, { useEffect, useState } from 'react'
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';
import { Alert, Button, ButtonGroup, Card, Col, Container, Dropdown, Form, ListGroup, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import CustomTableEdit from '../../components/CustomTableEdit';
import { useDispatch, useSelector } from 'react-redux';
import { getMatrizSucesion, saveSucesorMatrizSucesion, deleteSucesorMatrizSucesion } from '../../redux/Carrera_Sucesion/MatrizSucesion/actions';
import CustomPagint from '../../components/CustomPagint';

import "../../css/matrizSucesion.css";

import {
  getAllActiveEmployees,
  clearEmployees
} from "../../redux/employees/actions";


const MatrizSucesion = (props) => {

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const [Data, setData] = useState([]);
  const [filter, setFilter] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [tipoSucesor, setTipoSucesor] = useState("")
  const [selectedMatriz, setSelectedMatriz] = useState("")
  const [index, setIndex] = useState("")
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre"
  });
  const [showModalEmployees, setShowModalEmployees] = useState(false);
  const [validatedEmployee, setValidatedEmployee] = useState(false);

  const dispatch = useDispatch();

  const {
    loading,
    saveLoading,
    matrizSucesion,
    matrizSucesionLength,
    matrizSucesionError,
    formError


  } = useSelector((store) => store.matrizSucesion);
  const pages = Math.ceil(matrizSucesionLength / limit);

  const { employees, employeesFaild, loaderAllEmployees } = useSelector(
    (store) => store.employees
  );
  const filters = [
    { id: 'nombre', desc: 'Nombre' },
    { id: 'nivel_criticidad', desc: 'Nivel de Criticidad' },
    { id: 'promedio_nivel_criticidad', desc: 'Promedio Nivel Criticidad' },

    { id: 'responsable__nombre', desc: 'Nombre del Responsable' },
    { id: 'responsable__codigo', desc: 'Código del Responsable' },

    { id: 'empresa__codigo', desc: 'Código de la Empresa' },
    { id: 'empresa__tipo', desc: 'Tipo de Empresa' },
    { id: 'empresa__nombre', desc: 'Nombre de la Empresa' },

    { id: 'posicion_nombre', desc: 'Nombre de la Posición' },
    { id: 'posicion_codigo', desc: 'Código de la Posición' },

    { id: 'clasificacion_nombre', desc: 'Nombre de la Clasificación' },

    { id: 'unidad_organizativa_nombre', desc: 'Nombre de la Unidad Organizativa' },

    { id: 'unidad_organizativa_codigo', desc: 'Código de la Unidad Organizativa' }

  ]

  const filtersEmployees = [
    { id: "codigo", desc: "Código" },
    { id: "nombre", desc: "Nombre" },
  ];

  const [tipoBusquedaEmployee, setTipoBusquedaEmployee] = useState(
    filtersEmployees[0]
  );
  const history = useHistory();
  const goToPlanDeCarrera = (idMatriz, sucesor, funcion) => {
    let rowData = {
      funcion: funcion,
      sucesor: sucesor
    }
    history.push(
      {
        pathname: `/sucesion/plan-de-carrera-individual/${idMatriz}/${sucesor.titular__codigo}/${sucesor.titular__id}`,
        state: { rowData }
      }
    )

  }

  const _getMatrizSucesion = (offs = offset, lim = limit, filt = filter) => {
    dispatch(getMatrizSucesion({
      offset: offs,
      limit: lim,
      tipo_busqueda: tipoBusqueda.id,
      filter: filt
    }))
  }

  useEffect(() => {
    _getMatrizSucesion()
  }, [])


  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    _getMatrizSucesion(oOffset, limit, e.target.filter.value);
  };

  const submitNewSucesor = (sucesor) => {
    let _req = {
      nombre_titular: sucesor.nombre.toUpperCase(),
      tipo_titular: tipoSucesor,
      codigo_titular: sucesor.codigo,
      matriz_id: selectedMatriz
    }

    dispatch(saveSucesorMatrizSucesion(_req, index, setShowModalEmployees))
  }

  const columns = [
    {
      Header: "Nivel de Criticidad",
      accessor: "nivel_criticidad",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${value.row.original.nivel_criticidad === "Alta criticidad"
            ? "bg-danger text-light"
            : value.row.original.nivel_criticidad === "Media criticidad"
              ? "bg-warning text-light"
              : "bg-success text-light"
            } p-2 rounded-pill text-center`}
          style={{
            width: "160px",
          }}
        >
          {value.row.original.nivel_criticidad === "Alta criticidad"
            ? "Criticidad Alta"
            : value.row.original.nivel_criticidad === "Media criticidad"
              ? "Criticidad Media"
              : "Criticidad Baja"}
        </div>
      )



    },
    {
      Header: "Empresa",
      accessor: "empresa__nombre",
      Filter: "",
      Cell(value) {
        return (
          <div>
            {value.row.original.empresa[0].empresa__nombre}
          </div>
        )
      }


    },
    {
      Header: "Función Clave",
      accessor: "funcion_clave",
      Filter: "",
      Cell(value) {
        return (
          <div>
            {value.row.original.funcion[0].posicion__codigo + ' - ' + value.row.original.funcion[0].posicion__nombre}
          </div>
        )
      }

    },
    {
      Header: "Titular",
      accessor: "titulares",
      Filter: "",
      Cell(value) {

        return (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="main-container">
                {value.row.original.titulares.map(sucesor => (
                  <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>

                    <div key={sucesor.titular__id} className="container-option">
                      <span>{sucesor.titular__nombre}</span>
                    </div>

                  </div>
                ))}

              </div>

            </div>

          </>

        )

      }
    },
    {
      Header: "Sucesor Inmediato",
      accessor: "sucesor",
      Filter: "",
      Cell(value) {
        return (

          <div style={{ display: 'flex', alignItems: 'center' }}>

            {!value.row.original.sucesores_inmediatos || value.row.original.sucesores_inmediatos.length === 0 ?
              (

                <div className="sucesor-container">
                  <Alert variant="info">
                    Sin registros que mostrar.
                  </Alert>
                </div>
              )
              : (
                <div className="main-container">
                  {value.row.original.sucesores_inmediatos.map(sucesor => (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>
                      <div key={sucesor.titular__id} style={{ cursor: "pointer" }} className="container-option" onClick={() => goToPlanDeCarrera(value.row.original.id, sucesor, value.row.original.funcion[0])}>
                        <span>{sucesor.titular__nombre}</span>
                      </div>
                      <div className='delete-container' onClick={() => dispatch(deleteSucesorMatrizSucesion(sucesor.titular__id, value.row.index))}>
                        <i className="material-icons delete-icon">close</i>
                      </div>
                    </div>
                  ))}

                </div>
              )}
            <button
              style={{ marginLeft: '10px', backgroundColor: "transparent" }}
              onClick={() => {
                setIndex(value.row.index)
                setSelectedMatriz(value.row.original.id)
                setTipoSucesor("Sucesor Inmediato")
                setShowModalEmployees(true)
              }
              }
            >
              <i className="material-icons" style={{ color: 'blue', cursor: 'pointer' }}>add_circle</i>
            </button>
          </div>

        )

      }
    },
    {
      Header: "Sucesor en Formación",
      accessor: "sucesor_formacion",
      Filter: "",
      Cell(value) {
        return (

          <div style={{ display: 'flex', alignItems: 'center' }}>

            {!value.row.original.sucesores_formacion || value.row.original.sucesores_formacion.length === 0 ?
              (

                <div className="sucesor-container">
                  <Alert variant="info">
                    Sin registros que mostrar.
                  </Alert>
                </div>
              )
              : (
                <div className="main-container">
                  {value.row.original.sucesores_formacion.map(sucesor => (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>
                      <div key={sucesor.titular__id} style={{ cursor: "pointer" }} className="container-option" onClick={() => goToPlanDeCarrera(value.row.original.id, sucesor, value.row.original.funcion[0])}>
                        <span>{sucesor.titular__nombre}</span>
                      </div>
                      <div className='delete-container' onClick={() => dispatch(deleteSucesorMatrizSucesion(sucesor.titular__id, value.row.index))}>
                        <i className="material-icons delete-icon">close</i>
                      </div>
                    </div>
                  ))}

                </div>
              )}
            <button
              style={{ marginLeft: '10px', backgroundColor: "transparent" }}
              onClick={() => {
                setIndex(value.row.index)
                setSelectedMatriz(value.row.original.id)
                setTipoSucesor("Sucesor en Formación")
                setShowModalEmployees(true)
              }
              }
            >
              <i className="material-icons" style={{ color: 'blue', cursor: 'pointer' }}>add_circle</i>
            </button>
          </div>

        )

      }
    },
    {
      Header: "Sucesor Posterior",
      accessor: "sucesor_posterior",
      Filter: "",
      Cell(value) {
        return (

          <div style={{ display: 'flex', alignItems: 'center' }}>

            {!value.row.original.sucesores_posteriores || value.row.original.sucesores_posteriores.length === 0 ?
              (

                <div className="sucesor-container">
                  <Alert variant="info">
                    Sin registros que mostrar.
                  </Alert>
                </div>
              )
              : (
                <div className="main-container">
                  {value.row.original.sucesores_posteriores.map(sucesor => (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>
                      <div key={sucesor.id} className="container-option" style={{ cursor: "pointer" }} onClick={() => goToPlanDeCarrera(value.row.original.id, sucesor, value.row.original.funcion[0])}>
                        <span>{sucesor.titular__nombre}</span>
                      </div>
                      <div className='delete-container' onClick={() => dispatch(deleteSucesorMatrizSucesion(sucesor.titular__id, value.row.index))}>
                        <i className="material-icons delete-icon">close</i>
                      </div>
                    </div>
                  ))}

                </div>
              )}
            <button
              style={{ marginLeft: '10px', backgroundColor: "transparent" }}
              onClick={() => {
                setIndex(value.row.index)
                setSelectedMatriz(value.row.original.id)
                setTipoSucesor("Sucesor Posterior")
                setShowModalEmployees(true)
              }
              }
            >
              <i className="material-icons" style={{ color: 'blue', cursor: 'pointer' }}>add_circle</i>
            </button>
          </div>

        )
      }
    }


  ]

  const handleUpdateData = (updatedData) => {
    setData(updatedData);
  };

  //Ver todos los registros 
  const seeAll = () => {
    const Search = "";
    setFilter(Search);
    const Offset = 0;
    setOffset(Offset);
    setCurrentPage(1);
    getMatrizSucesion(Offset, limit, Search);
  }

  const onSearchEmployee = (e) => {
    //e.preventDefault();
    if (e.key === "Enter") {
      if (!e.target.value.trim()) {
        setValidatedEmployee(true);
      } else {
        setValidatedEmployee(false);
        dispatch(
          getAllActiveEmployees({
            tipo_busqueda: tipoBusquedaEmployee.id,
            filter: e.target.value,
          })
        );
      }
    }
  };

  const _clearEmployees = (e) => {
    setValidatedEmployee(false);
    dispatch(clearEmployees());
  }


  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className='custom-wrapper'>
        <Container fluid>
          <div className='my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center'>
            <h6 className='font-weight-bold text-uppercase'>Matriz de sucesión</h6>
            <Form onSubmit={onSearch}>
              <Row className='justify-content-end align-items-center flex-wrap justify-content-between align-items-center'>
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name='filter'
                    id='filter'
                    placeholder='Buscar'
                    className='rounded-pill form-control-sm'
                    type='search'
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant='light'
                      size='sm'
                      className='rounded-circle'
                      onClick={() => seeAll()}
                    >
                      <i className='material-icons'>list</i>
                    </Button>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement='auto'
                        overlay={
                          <Tooltip>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className='ml-3 mr-3'>
                          <Dropdown.Toggle
                            variant='light'
                            className='btn-sm font rounded-pill'
                          >
                            <i className='material-icons'>filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>

                      </OverlayTrigger>
                    </ButtonGroup>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner
                animation='border'
                role='status'
                className='d-flex justify-content-center'
              />
            </div>
          ) : (
            matrizSucesionLength > 0 && (
              <>
                <Card className='border-0'>
                  <Card.Body className='px-1 px-sm-2'>
                    <CustomTableEdit columns={columns} data={matrizSucesion} updateData={handleUpdateData} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={matrizSucesionLength}
                  pages={pages}
                  pagFunc={_getMatrizSucesion}

                />
              </>
            )
          )}
        </Container>
      </div>
      <Modal
        show={showModalEmployees}
        onHide={() => {
          _clearEmployees()
          setShowModalEmployees(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buscar Colaborador</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-end align-items-center flex-nowrap">
            {!!formError && (
              <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                {formError}
              </Alert>
            )}
            <Col xs="auto">
              <Form.Label className="m-0" htmlFor="filterEmployee">
                <b>{tipoBusquedaEmployee.desc}:</b>
              </Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Control
                id="filterEmployee"
                name="filterEmployee"
                // placeholder="Buscar Colaborador"
                required
                className={`rounded-pill form-control-sm ${validatedEmployee ? "is-invalid" : ""
                  }`}
                type="search"
                onKeyDown={onSearchEmployee}
              //value={searchEmployee}
              //onChange={e => setSearchEmployee(e.target.value)}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Col>
            <Col>
              <ButtonGroup>
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip>Seleccionar Filtrado</Tooltip>}
                >
                  <Dropdown className="ml-3 mr-3">
                    <Dropdown.Toggle
                      variant="light"
                      className="btn-sm font rounded-pill"
                    >
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filtersEmployees.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusquedaEmployee(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </OverlayTrigger>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="my-3">
            {employeesFaild ? (
              <Alert variant="error" className="my-4">
                {employeesFaild}
              </Alert>
            ) : null}
            {loaderAllEmployees ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : employees.length > 0 ? (
              <ListGroup variant="flush">
                {employees.map((employee) => (
                  <ListGroup.Item className="d-flex flex-wrap justify-content-between align-items-center">
                    <p className="m-0">
                      {employee.codigo} {employee.nombre}
                    </p>
                    <Button
                      onClick={() => {
                        submitNewSucesor(employee)
                      }}
                      disabled={saveLoading}
                      size="sm"
                      variant="primary"
                      className="rounded-circle"
                    >
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      <i className="material-icons">person_add</i>
                    </Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            ) : (
              <Alert variant="info" className="my-4">
                Sin registros que mostrar.
              </Alert>
            )}
          </div>
        </Modal.Body>


      </Modal>
    </>

  )
}

export default MatrizSucesion;